export default {"src":"/_next/static/media/oh-no.ace1784b.gif","height":512,"width":512,"blurWidth":0,"blurHeight":0};